export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Une Entreprise Familiale de Confiance
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Créée en <strong>2020</strong>, MECA SERVICES est une <strong>société familiale</strong> spécialisée dans la <strong>fourniture et l'installation de matériel de chauffage</strong> de haute qualité. Notre expertise couvre les <strong>pompes à chaleur air/eau</strong>, <strong>air/air</strong>, les <strong>ballons thermodynamiques</strong> et l'<strong>isolation</strong>.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Nous nous engageons à offrir des solutions énergétiques durables et performantes pour les <strong>particuliers</strong>, en garantissant un service personnalisé et professionnel à chaque étape de votre projet.
            </p>
            <div className="grid grid-cols-3 gap-6 mt-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">2020</div>
                <div className="text-sm text-gray-600">Année de création</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">100%</div>
                <div className="text-sm text-gray-600">Satisfaction client</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">500+</div>
                <div className="text-sm text-gray-600">Installations</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" style={{ width: '100%', height: '500px' }}>
              <img
                src="https://public.readdy.ai/ai/img_res/c1a5336e753439db1506bf4b1d50f44c.jpg"
                alt="Installation professionnelle"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-teal-600 text-white p-6 rounded-xl shadow-xl">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <div>
                  <div className="font-bold text-lg">Garantie</div>
                  <div className="text-sm opacity-90">Qualité assurée</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
